import { useEffect, useState, useRef, useContext } from "react";
import { Link } from "react-router-dom";

import { LayoutContext } from "../layout/";

import { cookie } from 'shared-kernel/helpers';

import Loader from "../loader";
import { getEndpoint } from "../helper";

export default function Search({ searchText }) {
    const [data, setData] = useState(null);
    const [products, setProducts] = useState([]);
    const [brands, setBrands] = useState([]);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);

    const { setCartCount, setPageTitle } = useContext(LayoutContext);

    const controllerRef = useRef(null);

    const fetchData = async () => {
        controllerRef.current = new AbortController();
        const signal = controllerRef.current.signal;

        try {
            setLoading(true);
            const response = await fetch(getEndpoint(`/api/android/search/find?q=${searchText}`), { signal });

            const json = await response.json();
            setData(json.data);
            setProducts(json.data.filter(x => !x.isSuggestion));
            setBrands(json.data.filter(x => x.isSuggestion));
        } catch (err) {
            if (err.name !== "AbortError") setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    const formatNumber = n => n == null ? '' : n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    const addToCart = (productId, brandId, customProductId) => {
        fetch(getEndpoint('/api/cart/submit'), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                id: undefined,
                cartId: cookie.get('cid'),
                productId,
                brandId,
                customProductId,
                quantity: 1
            })
        })
            .then(res => res.json())
            .then(data => {
                cookie.set('cid', data.data);

                fetch(getEndpoint(`/api/cart/get?cartid=${data.data}`))
                    .then(res => res.json())
                    .then(data => {
                        let quantitySum = data.data.reduce((p, c) => p += c.quantity, 0);

                        setCartCount(quantitySum);
                    });
            })
            .catch(err => console.error(err));
    }

    const ProductBox = ({ productId, categoryId, brandId, customProductId, picture, productTitle, brandTitle, price, oldPrice, discount, quantity, isCustomProduct }) => {
        const DivOrLink = ({ children }) => {
            return isCustomProduct
                ? <Link className='box d-f bc-w bw-1 bc--n3 br-3 mb-4' children={children} to={`/product/${productId}/${categoryId}`} />
                : <div className='box d-f bc-w bw-1 bc--n3 br-3 mb-4' children={children} />;
        }

        return (
            <DivOrLink>
                <div className='fsh-0 fg-0' style={{ backgroundColor: '#dddddd', width: '28%' }}>
                    <img src={getEndpoint(`/uploads/shop/product-file/${picture}`)} />
                </div>
                <div className='px-2' style={{ width: '82%' }}>
                    <div className='p-r t-1'>
                        <div className='lh-2' style={{ height: '3.2rem' }}>{productTitle}</div>
                        <div className='p-r' style={{ height: '1.4rem', fontSize: '.75em', color: '#777777', top: '.2rem' }}>{brandTitle}</div>
                    </div>
                    <div className='d-f ai-c p-r' style={{ top: '.4rem' }}>
                        <div className='d-f ai-c jc-c _bc-g-d c-w p-1 br-4'>
                            <div className='d-l fs-2'>{discount}%</div>
                        </div>
                        <div className='mr-2 fw-600' style={{ height: '4.4rem' }}>
                            <div className='d-f ai-c'>
                                <div className='fs-1' style={{ color: '#9c9c9c', textDecorationLine: 'line-through' }}>{formatNumber(oldPrice)}</div>
                                &nbsp;
                                <div style={{ color: '#9c9c9c', fontSize: '.8em' }}>ریال</div>
                            </div>
                            <div className='d-f ai-c p-r _c-b_b' style={{ top: '-.3em' }}>
                                <div className='fs-2' style={{}}>{formatNumber(price)}</div>
                                &nbsp;
                                <div style={{ fontSize: '.8em' }}>ریال</div></div>
                        </div>
                        {!isCustomProduct && <div className='_bc-o d-if mr-a p-2 br-3' onClick={e => addToCart(productId, brandId, customProductId)}>
                            <img style={{ width: '1.7rem' }} src={getEndpoint("/pwa/img/icons/add2basket.svg")} />
                        </div>}
                    </div>
                </div>
            </DivOrLink>
        );
    }

    const BrandBox = ({ categoryId, brandId, picture, categoryTitle, brandTitle }) => {
        return (
            <Link className='box d-f ai-c bc-w bw-1 bc--n3 br-3 mb-4' to={`/brand/${brandId}/${categoryId}`}>
                <div className='fsh-0 fg-0' style={{ backgroundColor: '#dddddd', width: '28%' }}>
                    <img src={getEndpoint(`/uploads/shop/brand/${picture}`)} />
                </div>
                <div className='px-2' style={{ width: '82%' }}>
                    <div className='p-r t-1'>
                        <div style={{ fontSize: '1.3em' }}>{brandTitle}</div>
                        <div className='mt-1' style={{ color: '#757575', fontSize: '1.1em' }}>در {categoryTitle}</div>
                    </div>
                </div>
            </Link>
        );
    }

    useEffect(() => {
        setPageTitle('');
    }, []);

    useEffect(() => {
        const delay = setTimeout(() => {
            if (searchText.trim() !== "") fetchData();
            else {
                if (data !== null) setData([]);
            }
        }, 600);

        return () => clearTimeout(delay);
    }, [searchText]);

    if (loading) return <Loader />;
    if (error) return <p>Error: {error}</p>;

    if (data == null) return null;

    if (data.length === 0) {
        return (
            <div className='minh-100 p-r'>
                <div className='p-a l-0 r-0 t-0 d-f ai-c jc-c' style={{ bottom: '6rem', height: 'calc(100vh - 6rem)' }}>
                    <div className=''>
                        <img className="w-9 mx-a mb-4" src={getEndpoint("/pwa/img/icons/paper2.svg")} />
                        <div style={{ color: '#707070' }}>داده ای برای نمایش وجود ندارد</div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div style={{ backgroundColor: '#f5f5f5', paddingBottom: '6rem' }}>
            {brands.length > 0 && <div className='mx-4 mt-4 mb-2' style={{ color: '#757575', fontSize: '1.2em' }} children='ورود به صفحه:' />}
            {brands.length > 0 && (
                <div className='px-4 mb-2'>
                    {brands.map(x => {
                        return (
                            <BrandBox
                                key={`${x.productId}_${x.brandId}`}
                                categoryId={x.categoryId}
                                brandId={x.brandId}
                                picture={x.brandPic}
                                categoryTitle={x.categoryTitle}
                                brandTitle={x.brandTitle}
                            />
                        )
                    })}
                </div>
            )}
            {brands.length > 0 && <div style={{ backgroundColor: '#cccccc', height: '2px' }} />}
            {products.length > 0 && (
                <div className='p-4'>
                    {products.map(x => {
                        return (
                            <ProductBox
                                key={`${x.productId}_${x.brandId}`}
                                productId={x.productId}
                                categoryId={x.categoryId}
                                brandId={x.brandId}
                                customProductId={x.customProductId}
                                picture={x.productPic}
                                productTitle={x.productTitle}
                                brandTitle={x.brandTitle}
                                price={x.price}
                                oldPrice={x.oldPrice}
                                discount={x.discount}
                                quantity={x.quantity}
                                isCustomProduct={x.isCustomProduct}
                            />
                        )
                    })}
                </div>
            )}
        </div>
    );
}